// Como uma conversão se lê: data, custo e duração.
//
// Mora fora das telas porque a lista e o detalhe mostram os mesmos números, e
// duas cópias divergiriam na primeira vez que alguém mudasse a casa decimal.

export const formatGenerationDate = (value: string): string =>
	new Date(value).toLocaleString('pt-BR', {
		dateStyle: 'short',
		timeStyle: 'short',
	})

// O custo do pedido inteiro, e não a soma das questões: ler o caderno acontece
// uma vez, é a etapa mais cara do fluxo e não pertence a questão nenhuma.
// Quatro casas porque uma conversão inteira custa centavos.
export const formatGenerationCost = (value: number): string =>
	value > 0 ? `US$ ${Number(value).toFixed(4)}` : '—'

// Relógio de parede, do início à última questão. As questões rodam em paralelo,
// então somar as durações delas daria mais que o tempo real.
export const formatGenerationDuration = (value: number): string => {
	if (!value) {
		return '—'
	}

	const seconds = Math.round(value / 1000)

	return seconds < 60
		? `${seconds}s`
		: `${Math.floor(seconds / 60)}min ${String(seconds % 60).padStart(2, '0')}s`
}

// O motivo pelo qual a conversão não começou, como a API o descreveu.
//
// A API responde `{ message, detail }`, e o `detail` é a parte que diz o que
// fazer: "nenhum bloco corresponde à matriz \"Tipoa 1\"" manda corrigir o tipo,
// e "o caderno traz 4 versões e nenhuma foi declarada" manda declarar uma.
// A tela mostrava um texto fixo culpando a configuração do microserviço, e com
// ele quem enviou o caderno ia procurar defeito no lugar errado — ou abrir o
// JSON da resposta para descobrir o motivo de verdade.
//
// Nem toda falha chega como JSON: o proxy que recusa o caderno grande demais
// devolve HTML, e aí o que sobra de informação é o status.
export const describeGenerationError = (error: unknown): string => {
	const failure = error as {
		status?: number | string
		data?: unknown
	}

	const body = failure?.data as
		| { message?: unknown; detail?: unknown }
		| undefined

	const message = typeof body?.message === 'string' ? body.message : null
	const detail = typeof body?.detail === 'string' ? body.detail : null

	if (message && detail) {
		return `${message}: ${detail}`
	}

	if (message ?? detail) {
		return (message ?? detail) as string
	}

	return typeof failure?.status === 'number'
		? `Não foi possível iniciar a conversão. O servidor respondeu com status ${failure.status}.`
		: 'Não foi possível iniciar a conversão. Não houve resposta do servidor.'
}
